import { NotificationSummary } from '@app/common/models/notification-summary';

export class OperationResponse<TData> {
    constructor(public operationSucceeded: boolean, public data: TData, public notifications: Array<NotificationSummary>) { }
}
